module.exports = __webpack_public_path__ + "img/9-1.43b2ba6d.png";